<template>
  <q-header v-if="isLoggedIn">
    <q-toolbar class="bg-white text-primary">
      <!-- Hamburger button, shown only when the drawer is closed -->
      <q-btn icon="menu" v-if="!drawer" flat round @click="toggleDrawer" class="q-mr-sm" size="md" />

      <q-toolbar-title class="row items-center">
        <router-link to="/" class="logo-container">
          <img :src="logo" alt="Aims2024 Logo" style="height: 52px;">
        </router-link>
        <span class="page-title q-ml-lg">{{ pageTitle }}</span>
      </q-toolbar-title>

      <q-select
          filled
          v-model="selectedYear"
          :options="yearOptions"
          emit-value
          map-options
          style="max-width: 100px; font-size: 20px;"
          class="q-mr-md"
          />

      <!-- Dropdown for user actions -->
      <q-btn-dropdown flat icon="person" class="q-ml-auto">
        <q-list>
          <q-item clickable @click="goToProfile">
            <q-item-section>Profile</q-item-section>
          </q-item>
          <q-item clickable @click="logout">
            <q-item-section>Logout</q-item-section>
          </q-item>
        </q-list>
      </q-btn-dropdown>
    </q-toolbar>
  </q-header>
</template>

<script>
import { ref, watch } from 'vue';
import { QHeader, QToolbar, QToolbarTitle, QBtnDropdown, QList, QItem, QItemSection, QSelect, QBtn } from 'quasar'
import { useRouter, useRoute } from 'vue-router'
import { isLoggedIn, logout } from '../utils/auth'
import { selectedYear, yearOptions } from '../store/store'
import logo from '@/assets/aims2024.webp'

export default {
  name: 'NavBar',
  components: {
    QHeader,
    QToolbar,
    QToolbarTitle,
    QBtnDropdown,
    QList,
    QItem,
    QItemSection,
    QSelect,
    QBtn
  },
  props: {
    drawer: Boolean // Receive drawer state from parent
  },
  setup(props, { emit }) {
    const router = useRouter();
    const route = useRoute();
    const pageTitle = ref(route.meta.title || '');

    function goToProfile() {
      router.push('/profile');
    }

    // Emit toggle event to parent to control drawer state
    function toggleDrawer() {
      emit('toggleDrawer');
    }

    // Watch for changes in route.meta.title and update pageTitle
    watch(
      () => route.meta?.title,  // Watch only the route.meta.title
      (newTitle) => {
        if (newTitle) {
          pageTitle.value = newTitle || '';
        }
      },
      { immediate: true }  // Ensure the watcher runs immediately on component mount
    );

    return { isLoggedIn, logout, goToProfile, pageTitle, selectedYear, yearOptions, toggleDrawer, logo };
  }
}
</script>

<style lang="sass">
@import "@/styles/quasar.variables.sass"

.bg-white
  background-color: #fff !important

.text-primary
  color: $primary

.q-header
  box-shadow: none !important
  border-bottom: 1px solid $border-color

.logo-container
  display: flex
  justify-content: center
  align-items: center
  padding: 5px
  height: 64px
  width: 64px
  overflow: hidden

.logo-container img
  max-height: 100%
  max-width: 100%

.page-title
  color: black
  font-weight: bold

</style>
